import { Partner, Service } from '@raskrask-dk/bookingflow-state-machine'
import { RRDate } from '@raskrask-dk/raskrask-utils'
import { GoalBF, PackageBF, PartnerBF, ServiceBF } from '../../models'

export interface IReactModels {
  partners: PartnerBF[]
  services: ServiceBF[]
  goals: GoalBF[]
  packages: PackageBF[]
}

export const getCaruselDates = (
  numberOfDays: number,
  startDate: RRDate,
  service?: Service,
  selectedDate?: RRDate,
  partner?: Partner
): CarouselDates => {
  if (service === undefined) return []
  const loadedDays = [...Array(numberOfDays).keys()].map((_e, i) => {
    return new RRDate(
      startDate.toString('yyyy-MM-dd'),
      'yyyy-MM-dd'
    ).addDays(i)
  })

  const isPartnerSelected = partner !== undefined
  const avDates = isPartnerSelected
    ? partner.schedule.datesAvilabilities(service.duration)
    : service.getDates(loadedDays)

  const carouselDates: CarouselDates = loadedDays.map((ld) => {
    const isAv = avDates.some((ad) => ad.equals(ld))

    return {
      date: ld.toString('yyyy-MM-dd'),
      dayString: ld.toString('EEE').substring(0, 3).toUpperCase(),
      shortDate: ld.toString('d/M'),
      state:
        isAv &&
          selectedDate &&
          selectedDate.toString('yyyy-MM-dd') ===
          ld.toString('yyyy-MM-dd')
          ? 'selected'
          : isAv
            ? 'enabled'
            : 'disabled',
    }
  })

  return carouselDates
}
